import { Dropdown } from "antd";
import {
	DownOutlined,
	EditOutlined,
	PlayCircleOutlined,
	SwapOutlined,
	StopOutlined,
} from "@ant-design/icons";
import trans from "../../../utils";

const CLOSED_STATUSES = ["Completed", "Cancelled"];

export default function DispatcherPlanActions({
	plan,
	canEdit,
	onView,
	onEdit,
	onActivate,
	onAddRequests,
	onReassign,
	onCancel,
}) {
	const isClosed = CLOSED_STATUSES.includes(plan.status);

	const items = [];
	if (canEdit) {
		items.push({
			label: trans("Active Plan"),
			key: "activate",
			icon: <PlayCircleOutlined />,
			disabled: plan.status === "Active" || isClosed,
		});
		items.push({
			label: trans("Edit Plan"),
			key: "edit",
			icon: <EditOutlined />,
			disabled: isClosed,
		});

		items.push({
			label: trans("Reassign"),
			key: "reassign",
			icon: <SwapOutlined />,
			disabled: plan.status === "Cancelled" || plan.status === "Completed",
		});
		items.push({
			label: trans("Cancel Request"),
			key: "cancel",
			icon: <StopOutlined />,
			danger: true,
			disabled: plan.status === "Cancelled" || plan.status === "Completed",
		});
	}

	const handleMenuClick = ({ key }) => {
		if (key === "edit") onEdit(plan);
		if (key === "activate") onActivate(plan);
		if (key === "addRequests") onAddRequests(plan);
		if (key === "reassign") onReassign(plan);
		if (key === "cancel") onCancel(plan);
	};

	return (
		<Dropdown.Button
			icon={<DownOutlined />}
			className="custom-dropdown-button"
			menu={{ items, onClick: handleMenuClick }}
			onClick={() => onView(plan)}
		>
			{trans("view")}
		</Dropdown.Button>
	);
}
